import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { ProductInfo } from '@authsemply/shared';
import { AuthCard } from '../components/AuthCard';
import { APP_URL, loadProducts } from '../lib/products';

/**
 * Choix du produit après connexion. Avec un seul produit lancé, redirection
 * immédiate — cet écran n'existe que pour un vrai choix.
 */
export function ProductsPage() {
  const [products, setProducts] = useState<ProductInfo[] | null>(null);

  useEffect(() => {
    void loadProducts().then((list) => {
      if (list.length === 1) {
        window.location.replace(list[0].url);
        return;
      }
      // Aucun produit au catalogue (ou catalogue injoignable) : SEmplyApp,
      // plutôt qu'un écran de choix vide (02/10/2026).
      if (list.length === 0 && APP_URL) {
        window.location.replace(APP_URL);
        return;
      }
      setProducts(list);
    });
  }, []);

  if (!products) {
    return <AuthCard title="Chargement…">{null}</AuthCard>;
  }

  if (products.length === 0) {
    return (
      <AuthCard title="Vos outils SEmply">
        <p>Aucun outil n’est disponible pour le moment. Réessayez dans quelques instants.</p>
        <div className="links">
          <Link to="/compte">Mon compte</Link>
        </div>
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Où souhaitez-vous aller ?" subtitle="Un seul compte, tous vos outils SEmply.">
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {products.map((product) => (
          <li key={product.clientId} style={{ marginBottom: '0.75rem' }}>
            <a className="product-card" href={product.url}>
              <strong>{product.name}</strong>
              {product.description ? <span>{product.description}</span> : null}
            </a>
          </li>
        ))}
      </ul>
      {/* Création de dossier et abonnements, au portail (11/10/2026). */}
      <div className="links">
        <Link to="/dossiers/nouveau">Créer un dossier</Link>
        <Link to="/abonnements">Mes abonnements</Link>
        <Link to="/compte">Mon compte</Link>
      </div>
    </AuthCard>
  );
}
